import { render } from "./LetterEditor.vue?vue&type=template&id=79726d5c&scoped=true"
import script from "./LetterEditor.vue?vue&type=script&lang=js"
export * from "./LetterEditor.vue?vue&type=script&lang=js"

import "./LetterEditor.vue?vue&type=style&index=0&id=79726d5c&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79726d5c"]])

export default __exports__